import { Box, Tag, Text, TextColorToken, Tooltip } from '@betterment/samba-react';

type DataPointProps = {
  label: string;
  value: string;
  valueColor?: TextColorToken;
  explanation?: string;
  isBoostedActive?: boolean;
};

export const DataPoint = ({
  label,
  value,
  valueColor = 'text',
  explanation,
  isBoostedActive = false,
}: DataPointProps) => {
  return (
    <Box>
      <Box css={{ display: 'flex', gap: 'space.25' }}>
        <Text as="p" variant="text50" color="text.weak">
          {label}
        </Text>
        {explanation && (
          <Tooltip>
            <Tooltip.Trigger asChild={true}>
              <Tooltip.IconButton />
            </Tooltip.Trigger>
            <Tooltip.Content align="center" side="top">
              <Tooltip.Text dangerouslySetInnerHTML={{ __html: explanation }} />
            </Tooltip.Content>
          </Tooltip>
        )}
      </Box>
      <Box css={{ display: 'flex', gap: 'space.100' }}>
        <Text as="p" variant="text200" color={valueColor}>
          {value}
        </Text>
        {isBoostedActive && <Tag accent="teal">Boosted</Tag>}
      </Box>
    </Box>
  );
};
